module.exports = __webpack_public_path__ + "static/media/Jon1.e67ddfea.jpg";